import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Input,
  OnInit,
} from '@angular/core';
import { ModalController } from '@ionic/angular';
import {
  CashFund,
  CashFundSplitRow,
  CostCenterSummary,
  Identity,
} from '@libs/core/api';
import { FundCashSplitRowModalComponent } from '../fund-cash-split-row-modal/fund-cash-split-row-modal.component';

@Component({
  selector: 'front-end-fund-cash-split-list-modal',
  templateUrl: './fund-cash-split-list-modal.component.html',
  styleUrls: ['./fund-cash-split-list-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FundCashSplitListModalComponent implements OnInit {
  @Input() cashFund!: CashFund;
  @Input() project!: CostCenterSummary;
  @Input() identity!: Identity;

  splitRows: CashFundSplitRow[] = [];

  constructor(
    private readonly modalController: ModalController,
    private readonly cdr: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    this.splitRows = [...(this.cashFund.splitRows ?? [])];
  }

  get totalAmount(): number {
    return this.cashFund.authorizedAmount ?? 0;
  }

  get totalSplitAmount(): number {
    return this.splitRows.reduce((sum, row) => sum + (row.amount ?? 0), 0);
  }

  get parentAmount(): number {
    return this.totalAmount - this.totalSplitAmount;
  }

  async openAddSplitModal(): Promise<void> {
    const modal = await this.modalController.create({
      component: FundCashSplitRowModalComponent,
      componentProps: {
        project: this.project,
        identity: this.identity,
        maxAmount: this.parentAmount,
      },
    });

    await modal.present();

    const { data, role } = await modal.onWillDismiss<CashFundSplitRow>();

    if (role === 'apply' && data) {
      this.splitRows = [...this.splitRows, data];
      this.cdr.markForCheck();
    }
  }

  removeSplit(index: number): void {
    this.splitRows = this.splitRows.filter((_, i) => i !== index);
    this.cdr.markForCheck();
  }

  confirmSplits(): void {
    this.modalController.dismiss(this.splitRows, 'confirm');
  }

  close(): void {
    this.modalController.dismiss(null, 'cancel');
  }
}
